/**
 * Minimal Socket.IO client surface used by the notification realtime
 * channel (issue #416). Kept narrow and hand-rolled — like
 * flymsg-roleplay's `CopilotSocket` — so nothing outside
 * `NotificationSocketFactory` needs the real `socket.io-client` types.
 */
export interface NotificationSocket {
  connected: boolean;
  connect(): NotificationSocket;
  disconnect(): NotificationSocket;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  on(event: string, listener: (...args: any[]) => void): NotificationSocket;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  off(event: string, listener?: (...args: any[]) => void): NotificationSocket;
}

/** Payload the notification socket `auth` callback presents on (re)connect. */
export interface NotificationSocketAuthPayload {
  token: string;
}

/** `Socket.IO` `connect_error` — flymsg-node's realtime gateway reports its reason in `.message`. */
export interface NotificationConnectErrorEvent {
  message?: string;
}

export const NOTIFICATION_UNAUTHORIZED_PREFIX = "unauthorized:";
export const NOTIFICATION_TOKEN_EXPIRED_MESSAGE = "unauthorized: token expired";
